function initCeTimeline(){
 $('.timeline_post--expired').each(function () {
  if($(this).next().hasClass('timeline_post--expired')){
   $(this).addClass('timeline_post--expired--full');
  }
 })
}